import * as userActions from '../../reducers/user';
import sdk from '../../../sdk';
import * as utils from '../../../shared/utils';

const updateCustomerEmail = (email) => async (dispatch, getState) => {
  try {
    const { data: result } = await sdk.users.updateCustomerEmail(email);
    dispatch(
      userActions.updateUserSuccess(
        { result: { customer: { ...getState().user.customer, email } } },
      ),
    );

    return result;
  } catch (error) {
    const errorMessage = utils.getDataFromResponceError(error, 'msg');
    return { error: errorMessage };
  }
};

export default updateCustomerEmail;
